












/**
 * @module 渠道投放券弹窗
 * @tapd https://tapd.woa.com/HKpurse/prong/stories/view/1010145891886195565
 */

import { defineComponent, ref, watch, toRefs, computed } from '@vue/composition-api';
import CouponDialog from '../activity-module/coupon-module/coupon-dialog/index.vue';
import { useCouponLock } from '@/hooks/use-coupon-lock';
import { useCouponInfo } from './use-channel-coupon';

export default defineComponent({
  components: {
    CouponDialog,
  },
  props: {
    /**
         * 组件是否展示的前置条件，因为在某些情况下，希望该弹层先不要展开，等到某些条件达成时再展开
         * 对于需求而言，新用户进入印花专区时，要有限打开新用户领取弹窗，此时可通过isShow来控制
         */
    isShow: {
      type: Boolean,
      default: true,
    },
    /**
         * 该渠道券对应的couponId，
         * 为了增加灵活性，将来可以自己传入couponId来实现具体某张券的领取，因此不把从url中取id的逻辑写在此处
         * 而且由于从url中取id是一个前置逻辑，应该在顶层去做，而非等到组件都已经加载好了再来取
         */
    couponId: {
      type: String,
    },
    /**
         * 该渠道分发时，给coupon打的特殊tag的文案
         */
    couponTagText: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { isLock } = useCouponLock();
    const couponInfoDialog = ref();
    const { isShow, couponTagText } = toRefs(props);
    const couponData = useCouponInfo(props.couponId);

    const toggleDialog = () => {
      if (isShow.value && couponData.value && couponInfoDialog.value) {
        couponInfoDialog.value?.showCouponInfo();
      }
    };
    watch([isShow, couponData, couponInfoDialog], toggleDialog, { immediate: true });

    const couponInfo = computed(() => {
      if (!couponData.value) {
        return;
      }
      if (!couponTagText.value) {
        return couponData.value;
      }
      return {
        ...couponData.value,
        couponTagText: couponTagText.value,
      };
    });

    return {
      isLock,
      couponInfo,
      couponInfoDialog,
    };
  },
});
